import React, { useContext } from 'react';
import { Descriptions, Divider, Form, Input } from 'antd';
import { MCPResearchContext } from '../MCPResearchUI';
import EditCategory from './BasicDetails/EditCategory';
import EditText from './BasicDetails/EditText';
import PageHeader from './PageHeader';

const BasicDetails = () => {
    const { mcpAppDetails } = useContext(MCPResearchContext);
    const { basicDetails } = mcpAppDetails;
    const EditableFields = {
        endpoint_url: { key: 'endpoint_url', label: 'Endpoint URL', value: basicDetails?.endpoint_url },
        category_name: { key: 'category_name', label: 'Category', value: basicDetails?.MCPServerCategory?.category_name },
        gitrepo_link: { key: 'gitrepo_link', label: 'Git Repository Link', value: basicDetails?.gitrepo_link },
        gitrepo_version: { key: 'gitrepo_version', label: 'Git Repository Version', value: basicDetails?.gitrepo_version },
    };

    return (
        <div>
            <PageHeader />
            <div className='container'>
                <Descriptions size='small' labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label='Category'>
                        <EditCategory category={basicDetails?.MCPServerCategory?.category_name} />
                    </Descriptions.Item>
                    <Descriptions.Item label='Endpoint URL'>
                        <EditText text={basicDetails?.endpoint_url} fieldName={EditableFields.endpoint_url.key} />
                    </Descriptions.Item>
                    <Descriptions.Item label='Git Repository Link'>
                        <EditText text={basicDetails?.gitrepo_link} fieldName={EditableFields.gitrepo_link.key} />
                    </Descriptions.Item>
                    <Descriptions.Item label='Git Repo Version'>
                        <EditText text={basicDetails?.gitrepo_version} fieldName={EditableFields.gitrepo_version.key} />
                    </Descriptions.Item>
                    <Descriptions.Item label='Description' span={2}>
                        <Form.Item name={['basicDetails', 'description']} noStyle>
                            <Input.TextArea style={{ borderRadius: '0.5rem' }} rows={4} />
                        </Form.Item>
                    </Descriptions.Item>
                </Descriptions>
                <div className='ns-flex gap-4'>
                    <div className='ns-width-full'>
                        <Divider orientation='left'>Capabilities</Divider>
                        <Form.Item name={['basicDetails', 'capabilities']}>
                            <Input.TextArea style={{ borderRadius: '0.5rem' }} rows={16} />
                        </Form.Item>
                    </div>
                    <div className='ns-width-full'>
                        <Divider orientation='left'>Non ReadOnly Tools</Divider>
                        <Form.Item name={['basicDetails', 'non_readonly_tools']}>
                            <Input.TextArea style={{ borderRadius: '0.5rem' }} rows={16} />
                        </Form.Item>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BasicDetails;
